function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var FEATURED_SERVICES = '[data-component="featuredServices"]';
var FEATURED_SERVICES_CONTENT = '[data-element="featuredServiceContent"]';
var IS_OPENED_CLASS = 'is-opened';
var ARIA_EXPANDED = 'aria-expanded';
var ARIA_HIDDEN = 'aria-hidden';
var FeaturedServices = /*#__PURE__*/function () {
  function FeaturedServices(component) {
    var _this = this;
    _classCallCheck(this, FeaturedServices);
    this.services = document.querySelector(component);
    if (!this.services) return;
    this.btns = Array.from(this.services.querySelectorAll('[data-element="featuredServiceBtn"]'));
    this.btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        return _this.toggleServiceItem(btn);
      });
    });
  }
  return _createClass(FeaturedServices, [{
    key: "closeSiblings",
    value: function closeSiblings(data) {
      this.btns.forEach(function (btn) {
        var serviceItem = btn.parentNode;
        if (data.item !== serviceItem) {
          btn.setAttribute(ARIA_EXPANDED, false);
          serviceItem.classList.remove(IS_OPENED_CLASS);
          serviceItem.style.marginBottom = 0;
          serviceItem.querySelector(FEATURED_SERVICES_CONTENT).setAttribute(ARIA_HIDDEN, true);
        }
      });
    }
  }, {
    key: "closeServiceItem",
    value: function closeServiceItem(data) {
      data.item.classList.remove(IS_OPENED_CLASS);
      data.button.setAttribute(ARIA_EXPANDED, false);
      data.content.setAttribute(ARIA_HIDDEN, true);
      data.item.style.marginBottom = 0;
    }
  }, {
    key: "openServiceItem",
    value: function openServiceItem(data) {
      data.item.classList.add(IS_OPENED_CLASS);
      data.button.setAttribute(ARIA_EXPANDED, true);
      data.content.setAttribute(ARIA_HIDDEN, false);
      data.item.style.marginBottom = data.content.scrollHeight + 'px';
      this.closeSiblings(data);
    }
  }, {
    key: "toggleServiceItem",
    value: function toggleServiceItem(elm) {
      var serviceItem = elm.parentNode;
      var serviceItemContent = serviceItem.querySelector(FEATURED_SERVICES_CONTENT);
      var data = {
        button: elm,
        item: serviceItem,
        content: serviceItemContent
      };
      if (serviceItem.matches(".".concat(IS_OPENED_CLASS))) {
        this.closeServiceItem(data);
      } else {
        this.openServiceItem(data);
      }
    }
  }]);
}();
new FeaturedServices(FEATURED_SERVICES);